<svg class="svg-wrapper" [attr.width]="sizeInPx" [attr.height]="sizeInPx">
  <use class="svg-use" [attr.xlink:href]="svgName" />
</svg>
